import { debounce } from 'lodash';
import { RangeInputGroup } from '@cian/components';
import * as React from 'react';
import { IRange } from '../../../../common/types';
import { Label } from '../../../../ui/label/label';
import { connect } from 'react-redux';
import { IApplicationState, TTypedThunkDispatch } from '../../../../types/redux';
import { priceChange } from '../../../../actions/filter';

const styles = require('../fields.css');

interface IPriceProps {
  price: IRange;
  priceChange(square: IRange): void;
}

interface IPriceState {
  error: boolean;
  min: number | undefined;
  max: number | undefined;
}

class Price extends React.PureComponent<IPriceProps, IPriceState> {
  public state: IPriceState = {
    error: false,
    min: undefined,
    max: undefined,
  };

  public UNSAFE_componentWillMount() {
    this.setState({ min: this.props.price.min, max: this.props.price.max });

    this.validate();
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Readonly<IPriceProps>): void {
    this.setState({ min: nextProps.price.min, max: nextProps.price.max });
  }

  private setPriceMin = debounce((min: number | undefined) => {
    this.props.priceChange({ min, max: this.props.price.max });
  }, 1500);

  private setPriceMinValue = (min: number | undefined) => {
    this.setState({ min });

    this.setPriceMin(min);
  };

  private setPriceMax = debounce((max: number | undefined) => {
    this.props.priceChange({ min: this.props.price.min, max });
  }, 1500);

  private setPriceMaxValue = (max: number | undefined) => {
    this.setState({ max });

    this.setPriceMax(max);
  };

  public render() {
    const { error } = this.state;

    return (
      <Label text="Цена:">
        <RangeInputGroup
          errorTextCommon="Максимальное значение должно быть больше минимального"
          rangeGroupStyle={styles['range-group']}
          min={{
            disableFractional: true,
            disableNegative: true,
            error,
            inputStyle: styles['range-input'],
            maxLength: 9,
            name: 'min',
            onBlur: this.validate,
            onValueChange: this.setPriceMinValue,
            placeholder: 'от',
            value: this.state.min,
          }}
          max={{
            disableFractional: true,
            disableNegative: true,
            error,
            inputStyle: styles['range-input'],
            maxLength: 9,
            name: 'max',
            onBlur: this.validate,
            onValueChange: this.setPriceMaxValue,
            placeholder: 'до',
            value: this.state.max,
          }}
        />
        <span style={{ marginLeft: 10 }}>₽</span>
      </Label>
    );
  }

  private validate = () => {
    const { min, max } = this.props.price;

    this.setState({ error: min !== undefined && max !== undefined && min > max });
  };
}

export const PriceField = connect(
  (state: IApplicationState) => ({
    price: state.filter.query.price,
  }),
  (dispatch: TTypedThunkDispatch) => {
    return {
      priceChange: (square: IRange) => {
        dispatch(priceChange(square));
      },
    };
  },
)(Price);
